/**
 * Shows a login's display name for a UserId (notes authors, audit "changed by", the linked login).
 * Falls back quietly when the viewer cannot read users.
 */
import { useQuery } from '@tanstack/react-query';
import { useUserService } from '@actschurch/ccms-sdk';
import { Text } from '@/components/ui';

export function useUserLookup(userId?: string | null) {
  const userService = useUserService();
  return useQuery({
    queryKey: ['users', 'by-id', userId],
    queryFn: () => userService.getById(userId as string),
    enabled: !!userId && userId !== 'system',
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
}

export function UserName({ userId, fallback = 'Someone', size = 'sm' }: { userId?: string | null; fallback?: string; size?: string }) {
  const user = useUserLookup(userId);
  if (!userId) return <Text span size={size}>{fallback}</Text>;
  if (userId === 'system') return <Text span size={size}>The system</Text>;
  const u = user.data;
  const name = u ? (u.displayName || [u.firstName, u.surname].filter(Boolean).join(' ') || u.email) : null;
  return <Text span size={size}>{name || fallback}</Text>;
}
